//#region src/variants/variants_emoji.js
var variants_emoji_default = {
	defaults: { props: { size: { tokenCategory: "icon-size" } } },
	default: { props: { code: { initialValue: ":smile:" } } },
	unicode: { props: { code: { initialValue: "😄" } } },
	"custom size": { props: {
		code: { initialValue: ":thumbsup:" },
		size: { initialValue: "500" }
	} }
};
//#endregion
export { variants_emoji_default as default };

//# sourceMappingURL=variants_emoji.js.map